<template>
    <div class="dashboard-page">
        <!-- 顶部导航组件 -->
        <!-- <Top></Top> -->

        <!-- 主内容区容器 -->
        <div class="dashboard-container">
            <!-- 左侧卖家导航 -->
            <aside class="sidebar">
                <!-- 角色标识（保留，便于识别） -->
                <div class="role-tabs">
                    <button class="role-btn active">卖家中心</button>
                </div>

                <!-- 卖家导航菜单 -->
                <el-menu 
                  :default-active="activeMenu" 
                  class="nav-menu" 
                  background-color="#0f1118" 
                  text-color="#e2e8f0"
                  active-text-color="#38bdf8" 
                  unique-opened 
                  @select="handleMenuSelect"
                >
                    <el-menu-item index="seller-home"><i class="el-icon-s-shop"></i><span slot="title">卖家首页</span></el-menu-item>
                    <!-- <el-menu-item index="seller-promotion"><i class="el-icon-sale"></i><span slot="title">限时特惠</span></el-menu-item> -->
                    <el-menu-item index="seller-models">
                        <i class="el-icon-edit"></i>
                        <span slot="title">模型管理</span>
                    </el-menu-item>
                    <el-menu-item index="seller-invoice">
                        <i class="el-icon-postcard"></i>
                        <span slot="title">开票管理</span>
                    </el-menu-item>
                    <el-menu-item index="seller-apply">
                        <i class="el-icon-postcard"></i>
                        <span slot="title">发票管理</span>
                    </el-menu-item>
                    <!-- <el-submenu index="seller-content">
                        <template slot="title"><i class="el-icon-edit"></i><span>内容管理</span></template>
                        <el-menu-item index="seller-models">模型管理</el-menu-item>
                        <el-menu-item index="seller-category">分类管理</el-menu-item>
                        <el-menu-item index="seller-templates">模板设置</el-menu-item>
                    </el-submenu> -->
                    <!-- <el-submenu index="seller-sales">
                        <template slot="title"><i class="el-icon-shopping-cart-full"></i><span>销售管理</span></template>
                        <el-menu-item index="seller-orders">订单处理</el-menu-item>
                        <el-menu-item index="seller-refund">退款管理</el-menu-item>
                        <el-menu-item index="seller-comments">评价管理</el-menu-item>
                    </el-submenu> -->
                    <!-- <el-submenu index="seller-data">
                        <template slot="title"><i class="el-icon-pie-chart"></i><span>数据中心</span></template>
                        <el-menu-item index="seller-analysis">销售分析</el-menu-item>
                        <el-menu-item index="seller-traffic">流量分析</el-menu-item>
                        <el-menu-item index="seller-users">用户分析</el-menu-item>
                    </el-submenu> -->
                    <el-menu-item index="seller-withdraw">
                        <i class="el-icon-bank-card"></i>
                        <span slot="title">提现管理</span>
                    </el-menu-item>
                    <el-menu-item index="seller-info">
                        <i class="el-icon-user"></i>
                        <span slot="title">实名认证</span>
                    </el-menu-item>
                    <el-menu-item index="seller-enterprise">
                        <i class="el-icon-office-building"></i>
                        <span slot="title">企业认证</span>
                    </el-menu-item>
                </el-menu>
            </aside>

            <!-- 主内容区域 -->
            <main class="main-content">
                <router-view />
            </main>
        </div>

        <!-- 底部版权组件 -->
        <!-- <Bottom></Bottom> -->
    </div>
</template>

<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
    name: 'SellerDashboard',
    components: { Top, Bottom },
    data() {
        return {
            // 移除默认固定值，改为空
            activeMenu: '',
            dataTimeRange: 'month',
            chartType: 'sales',
            currentPage: 1,
            pageSize: 10,
            sellerOrderStatus: 'all',
            sellerSearchKey: '',
            orderDateRange: [],
            statusTagMap: { pending: 'warning', shipped: 'info', completed: 'success', refunding: 'danger' },
            sellerStatusTextMap: { pending: '待发货', shipped: '已发货', completed: '已完成', refunding: '退款中' }
        };
    },
    computed: {
        isHomePage() {
            const currentPath = this.$route.path;
            return currentPath.includes('seller/home');
        }
    },
    // 新增：页面创建时立即匹配当前路由
    created() {
        this.syncActiveMenuFromRoute();
    },
    watch: {
        $route: {
            // 深度监听 + 立即执行
            handler() {
                this.syncActiveMenuFromRoute();
            },
            immediate: true
        }
    },
    methods: {
        // 新增：统一方法 —— 从路由同步菜单激活状态
        syncActiveMenuFromRoute() {
            const pathSegments = this.$route.path.split('/');
            const page = pathSegments[3];
            if (page) {
                this.activeMenu = `seller-${page}`;
            } else {
                // 兜底默认值
                this.activeMenu = 'seller-home';
            }
        },

        // 菜单选择：更新激活状态并跳转路由
        handleMenuSelect(key) {
            this.activeMenu = key;
            this.currentPage = 1;
            const [role, page] = key.split('-');
            this.$router.push(`/dashboard/${role}/${page}`);
        },

        // 获取卖家页面标题
        getPageTitle() {
            const titleMap = {
                'seller/home': '商户首页',
                'seller/promotion': '限时特惠',
                'seller/models': '模型管理',
                'seller/invoice': '发票管理',
                'seller/category': '分类管理',
                'seller/templates': '模板设置',
                'seller/orders': '订单处理',
                'seller/refund': '退款管理',
                'seller/comments': '评价管理',
                'seller/analysis': '销售分析',
                'seller/traffic': '流量分析',
                'seller/users': '用户分析',
                'seller/withdraw': '提现管理',
                'seller/info': '商户信息'
            };
            const pathKey = this.$route.path.replace('/dashboard/', '');
            return titleMap[pathKey] || '智步云上-卖家中心';
        },

        // 快捷跳转：提现页面
        handleGoWithdraw() {
            this.$router.push('/dashboard/seller/withdraw');
        }
    }
};
</script>

<style lang="less" scoped>
// 深色主题配色
@bg-primary: #0f1118;
@text-primary: #e2e8f0;
@text-secondary: #a0aec0;
@accent-blue: #38bdf8;
@accent-red: #ef4444;
@accent-green: #10b981;
@accent-yellow: #f59e0b;
@card-bg: #1e293b;
@border-color: #4a5568;

// 全局样式 - 核心响应式优化
.dashboard-page {
    min-height: 100vh;
    background-color: @bg-primary;
    color: @text-primary;
    display: flex;
    flex-direction: column;
    width: 100%;
    // 移除固定最小宽度限制，解决移动端溢出问题
    // min-width: 1905px; 
    margin: 0 auto;
    overflow-x: hidden; // 防止横向溢出

    // 响应式断点定义
    @media screen and (max-width: 1200px) {
        padding: 0 5px;
    }

    @media screen and (max-width: 992px) {
        padding: 0;
    }

    @media screen and (max-width: 768px) {
        font-size: 14px;
    }

    @media screen and (max-width: 576px) {
        font-size: 13px;
    }
}

.dashboard-container {
    display: flex;
    flex: 1;
    gap: 15px;
    height: calc(100vh - 130px);
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;

    // 响应式布局调整
    @media screen and (max-width: 992px) {
        gap: 10px;
        padding: 0 5px;
        height: calc(100vh - 120px);
    }

    @media screen and (max-width: 768px) {
        flex-direction: column; // 移动端垂直布局
        height: auto;
        min-height: calc(100vh - 120px);
        gap: 15px;
        padding: 10px 5px;
    }

    @media screen and (max-width: 576px) {
        gap: 10px;
        padding: 5px;
    }
}

// 左侧侧边栏样式 - 响应式优化
.sidebar {
    width: 220px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    background-color: #080a12;
    flex-shrink: 0; // 防止侧边栏被压缩

    // 响应式调整
    @media screen and (max-width: 992px) {
        width: 200px;
    }

    @media screen and (max-width: 768px) {
        width: 100%;
        height: auto;
        max-height: 50vh;
        overflow-y: auto;
    }

    @media screen and (max-width: 576px) {
        width: 100%;
        gap: 5px;
    }

    .role-tabs {
        display: flex;
        border-bottom: 1px solid @border-color;

        @media screen and (max-width: 576px) {
            border-bottom: 1px solid rgba(74, 85, 104, 0.5);
        }

        .role-btn {
            flex: 1;
            padding: 12px 0;
            background: #1a202c;
            border: none;
            color: @text-secondary;
            font-size: 16px;
            cursor: default;
            transition: all 0.3s;

            &.active {
                background: @card-bg;
                color: @accent-blue;
            }

            // 响应式调整
            @media screen and (max-width: 992px) {
                padding: 10px 0;
                font-size: 15px;
            }

            @media screen and (max-width: 576px) {
                padding: 8px 0;
                font-size: 14px;
            }
        }
    }

    .nav-menu {
        border-radius: 4px;
        height: calc(100% - 50px);
        border-right: none;

        // 响应式调整
        @media screen and (max-width: 768px) {
            height: auto;
            max-height: calc(100% - 46px);
        }

        @media screen and (max-width: 576px) {
            height: auto;
            max-height: 300px;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(56, 189, 248, 0.3);
            border-radius: 3px;
        }

        // 菜单样式优化：点击区域扩大
        .el-menu-item {
            height: auto !important;
            cursor: pointer;
            width: 100%;
            box-sizing: border-box;

            &.is-active {
                background-color: rgba(56, 189, 248, 0.1) !important;
                color: @accent-blue !important;
                border-left: 3px solid @accent-blue;
            }

            &:hover {
                background-color: rgba(56, 189, 248, 0.05) !important;
            }

            > div {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 8px 15px; // 增加内边距，提升触控体验

                @media screen and (max-width: 576px) {
                    padding: 10px 15px;
                    gap: 8px;
                }
            }

            span[slot="title"] {
                flex: 1;
                display: inline-block;
                padding: 5px 0;

                @media screen and (max-width: 576px) {
                    font-size: 13px;
                }
            }

            i {
                font-size: 16px;

                @media screen and (max-width: 576px) {
                    font-size: 14px;
                }
            }
        }
    }
}

// 主内容区样式 - 响应式优化
.main-content {
    flex: 1;
    overflow-y: auto;
    padding: 5px;
    min-width: 0; // 解决flex容器溢出问题

    // 响应式调整
    @media screen and (max-width: 992px) {
        padding: 5px;
    }

    @media screen and (max-width: 768px) {
        padding: 10px;
        overflow-y: visible;
    }

    @media screen and (max-width: 576px) {
        padding: 5px;
    }

    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
            flex-wrap: wrap;
            gap: 10px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
            flex-direction: column;
            align-items: flex-start;
        }

        .page-title {
            font-size: 20px;
            color: @text-primary;
            margin: 0;

            // 响应式调整
            @media screen and (max-width: 992px) {
                font-size: 18px;
            }

            @media screen and (max-width: 576px) {
                font-size: 16px;
            }
        }
    }

    // 用户信息卡片样式
    .user-info-card {
        margin-bottom: 15px;
        background: #080a12;
        border: none;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
        }

        .user-info-wrapper {
            display: flex;
            flex-wrap: wrap; // 允许换行
            gap: 20px;
            align-items: center;

            // 响应式调整
            @media screen and (max-width: 992px) {
                gap: 15px;
            }

            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 15px;
            }

            @media screen and (max-width: 576px) {
                gap: 10px;
            }

            .user-avatar-section {
                display: flex;
                align-items: center;
                gap: 15px;
                flex: 1;
                min-width: 280px; // 最小宽度保证布局

                // 响应式调整
                @media screen and (max-width: 768px) {
                    width: 100%;
                    min-width: 0;
                }

                @media screen and (max-width: 576px) {
                    gap: 10px;
                    flex-direction: column;
                    align-items: flex-start;
                }

                .user-avatar {
                    border: 3px solid #f0f2f5;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        width: 60px !important;
                        height: 60px !important;
                    }
                }

                .user-base-info {
                    .user-name-role {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 8px;

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            margin-bottom: 5px;
                            gap: 8px;
                        }

                        .user-name {
                            font-size: 18px;
                            margin: 0;
                            color: #fff;

                            // 响应式调整
                            @media screen and (max-width: 992px) {
                                font-size: 16px;
                            }

                            @media screen and (max-width: 576px) {
                                font-size: 15px;
                            }
                        }
                    }

                    .user-memorial {
                        font-size: 13px;
                        color: @text-secondary;
                        line-height: 1.6;
                        margin: 0 0 10px 0;

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            font-size: 12px;
                            margin-bottom: 8px;
                        }
                    }

                    .user-actions {
                        display: flex;
                        gap: 10px;

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            gap: 8px;
                            flex-wrap: wrap;
                        }
                    }
                }
            }

            .user-stats {
                display: flex;
                align-items: center;
                gap: 20px;
                min-width: 300px;

                // 响应式调整
                @media screen and (max-width: 992px) {
                    gap: 15px;
                    min-width: 250px;
                }

                @media screen and (max-width: 768px) {
                    width: 100%;
                    min-width: 0;
                    justify-content: space-around;
                }

                @media screen and (max-width: 576px) {
                    gap: 10px;
                    justify-content: space-between;
                }

                .stat-item {
                    text-align: center;
                    min-width: 80px;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        min-width: 60px;
                    }
                }
            }
        }
    }

    // 内容卡片通用样式
    .content-card {
        color: #fff;
        margin-bottom: 15px;
        background: #080a12;
        border: none;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
        }

        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                flex-wrap: wrap;
                gap: 8px;
                padding: 8px 10px;
            }

            .card-title {
                font-size: 16px;
                font-weight: 500;

                // 响应式调整
                @media screen and (max-width: 992px) {
                    font-size: 15px;
                }

                @media screen and (max-width: 576px) {
                    font-size: 14px;
                }
            }

            .more-link,
            .refresh-btn {
                font-size: 13px;
                padding: 0;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    font-size: 12px;
                }
            }
        }
    }

    // 订单筛选栏样式
    .order-filter-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding: 0 5px;
        flex-wrap: wrap; // 允许换行
        gap: 10px;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
            flex-direction: column;
            align-items: flex-start;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
            gap: 8px;
        }

        .status-filter {
            display: flex;
            gap: 8px;
            flex-wrap: wrap;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
                width: 100%;
            }

            .el-radio-button {
                background-color: #2d3748;
                border-color: @border-color;
                color: @text-secondary;
                font-size: 12px;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 5px 8px;
                    font-size: 11px;
                }

                &.is-active {
                    background-color: @accent-blue;
                    border-color: @accent-blue;
                    color: #fff;
                }
            }
        }

        .seller-filter-group {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;

            // 响应式调整
            @media screen and (max-width: 768px) {
                width: 100%;
                gap: 8px;
            }

            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .order-search {
                width: 260px;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    width: 100%;
                }

                .el-input__inner {
                    background-color: #2d3748;
                    border-color: @border-color;
                    color: @text-primary;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        font-size: 12px;
                        padding: 8px 10px;
                    }
                }
            }

            .date-filter {
                min-width: 180px;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    width: 100%;
                }

                .el-input__inner {
                    background-color: #2d3748;
                    border-color: @border-color;
                    color: @text-primary;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        font-size: 12px;
                        padding: 8px 10px;
                    }
                }
            }
        }
    }

    // 原生订单表格样式
    .native-table-container {
        overflow-x: auto;
        margin-bottom: 15px;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
        }
    }

    .native-order-table {
        width: 100%;
        border-collapse: collapse;
        color: @text-primary;
        min-width: 600px; // 保证表格最小宽度，允许横向滚动

        // 响应式调整
        @media screen and (max-width: 768px) {
            min-width: 500px;
            font-size: 13px;
        }

        @media screen and (max-width: 576px) {
            min-width: 400px;
            font-size: 12px;
        }

        th {
            background-color: #2d3748;
            padding: 12px 8px;
            text-align: left;
            border: 1px solid @border-color;
            font-weight: 500;

            // 响应式调整
            @media screen and (max-width: 768px) {
                padding: 10px 6px;
            }

            @media screen and (max-width: 576px) {
                padding: 8px 4px;
                font-size: 11px;
            }
        }

        td {
            padding: 12px 8px;
            border: 1px solid @border-color;

            // 响应式调整
            @media screen and (max-width: 768px) {
                padding: 10px 6px;
            }

            @media screen and (max-width: 576px) {
                padding: 8px 4px;
            }
        }

        .order-row {
            background-color: @card-bg;
            transition: background-color 0.2s;

            &:hover {
                background-color: #232f45;
            }
        }

        .empty-row {
            background-color: @card-bg;

            td {
                color: @text-secondary;
                text-align: center;
            }
        }

        // 商品信息样式
        .order-product-info {
            display: flex;
            align-items: center;
            gap: 10px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .product-thumb {
                width: 40px;
                height: 40px;
                border-radius: 4px;
                object-fit: cover;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    width: 30px;
                    height: 30px;
                }
            }

            .product-name {
                max-width: 220px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    max-width: 150px;
                }

                @media screen and (max-width: 576px) {
                    max-width: 100px;
                }
            }
        }

        // 买家信息样式
        .buyer-info {
            display: flex;
            align-items: center;
            gap: 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .buyer-avatar {
                width: 30px;
                height: 30px;
                border-radius: 10%;
                object-fit: cover;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    width: 25px;
                    height: 25px;
                }
            }

            .buyer-name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 120px;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    max-width: 80px;
                }
            }
        }

        // 金额文本样式
        .amount-text {
            color: @accent-red;
            font-weight: 500;
        }

        // 订单状态标签样式
        .status-tag {
            display: inline-block;
            padding: 3px 8px;
            border-radius: 4px;
            font-size: 12px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                padding: 2px 6px;
                font-size: 11px;
            }

            &--warning {
                background-color: rgba(245, 158, 11, 0.2);
                color: @accent-yellow;
                border: 1px solid @accent-yellow;
            }

            &--info {
                background-color: rgba(56, 189, 248, 0.2);
                color: @accent-blue;
                border: 1px solid @accent-blue;
            }

            &--success {
                background-color: rgba(16, 185, 129, 0.2);
                color: @accent-green;
                border: 1px solid @accent-green;
            }

            &--danger {
                background-color: rgba(239, 68, 68, 0.2);
                color: @accent-red;
                border: 1px solid @accent-red;
            }
        }
    }

    // 原生按钮样式
    .native-btn {
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
        border: none;
        transition: background-color 0.2s;

        // 响应式调整 - 增大移动端按钮尺寸
        @media screen and (max-width: 576px) {
            padding: 6px 10px;
            font-size: 12px;
            min-height: 30px;
        }

        &--primary {
            background-color: @accent-blue;
            color: #fff;

            &:hover {
                background-color: #25a5e7;
            }
        }

        &--success {
            background-color: @accent-green;
            color: #fff;

            &:hover {
                background-color: #0e9f7a;
            }
        }

        &--info {
            background-color: #4a5568;
            color: @text-primary;

            &:hover {
                background-color: #374151;
            }
        }

        &--text {
            background-color: transparent;
            padding: 4px 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                padding: 6px 8px;
            }

            &.detail-btn {
                color: @accent-blue;

                &:hover {
                    color: #25a5e7;
                    text-decoration: underline;
                }
            }

            &.refund-btn {
                color: @accent-red;

                &:hover {
                    color: #dc2626;
                    text-decoration: underline;
                }
            }
        }
    }

    // 原生分页样式
    .native-pagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 15px;
        color: @text-secondary;
        font-size: 13px;
        flex-wrap: wrap; // 允许换行

        // 响应式调整
        @media screen and (max-width: 768px) {
            gap: 10px;
            font-size: 12px;
            justify-content: center;
        }

        @media screen and (max-width: 576px) {
            gap: 8px;
            font-size: 11px;
        }

        .pagination-total {
            margin-right: auto;

            // 响应式调整
            @media screen and (max-width: 768px) {
                margin-right: 0;
                width: 100%;
                text-align: center;
                margin-bottom: 5px;
            }
        }

        .pagination-sizes {
            display: flex;
            align-items: center;
            gap: 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .pagination-select {
                background-color: #2d3748;
                border: 1px solid @border-color;
                color: @text-primary;
                padding: 4px 8px;
                border-radius: 4px;
                cursor: pointer;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 4px 6px;
                    font-size: 11px;
                }
            }
        }

        .pagination-pages {
            display: flex;
            align-items: center;
            gap: 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .pagination-btn {
                background-color: #2d3748;
                border: 1px solid @border-color;
                color: @text-secondary;
                padding: 4px 12px;
                border-radius: 4px;
                cursor: pointer;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 4px 8px;
                    min-width: 30px;
                }

                &:hover:not(:disabled) {
                    background-color: #374151;
                    color: @accent-blue;
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            }

            .pagination-current {
                padding: 4px 12px;
                background-color: @accent-blue;
                color: #fff;
                border-radius: 4px;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 4px 8px;
                    min-width: 30px;
                    text-align: center;
                }
            }
        }
    }

    // 卖家内容区专属样式
    .seller-content {
        .data-tabs {
            margin-bottom: 15px;

            // 响应式调整
            @media screen and (max-width: 768px) {
                margin-bottom: 12px;
            }

            @media screen and (max-width: 576px) {
                margin-bottom: 10px;
            }
        }

        .sales-overview {
            display: flex;
            flex-wrap: wrap; // 允许换行
            gap: 20px;
            align-items: center;

            // 响应式调整
            @media screen and (max-width: 992px) {
                gap: 15px;
            }

            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 15px;
            }

            @media screen and (max-width: 576px) {
                gap: 10px;
            }

            .sales-amount {
                flex: 1;
                min-width: 200px;
                text-align: center;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    width: 100%;
                    min-width: 0;
                    text-align: left;
                }

                .amount-label {
                    display: block;
                    font-size: 14px;
                    color: @text-secondary;
                    margin-bottom: 5px;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        font-size: 12px;
                        margin-bottom: 3px;
                    }
                }
            }

            .sales-meta {
                flex: 2;
                min-width: 400px;

                // 响应式调整
                @media screen and (max-width: 992px) {
                    min-width: 300px;
                }

                @media screen and (max-width: 768px) {
                    width: 100%;
                    min-width: 0;
                }

                @media screen and (max-width: 576px) {
                    min-width: 0;
                }
            }
        }

        .chart-container {
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;

            // 响应式调整
            @media screen and (max-width: 992px) {
                height: 250px;
            }

            @media screen and (max-width: 768px) {
                height: 200px;
            }

            @media screen and (max-width: 576px) {
                height: 180px;
            }

            .chart-placeholder {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
        }

        .overview-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
            gap: 15px;

            // 响应式调整
            @media screen and (max-width: 992px) {
                grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
                gap: 12px;
            }

            @media screen and (max-width: 768px) {
                grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
                gap: 10px;
            }

            @media screen and (max-width: 576px) {
                grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
                gap: 8px;
            }

            .overview-item {
                text-align: center;
                padding: 15px 10px;
                background-color: #2d3748;
                border-radius: 4px;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    padding: 12px 8px;
                }

                @media screen and (max-width: 576px) {
                    padding: 10px 5px;
                    font-size: 12px;
                }

                .el-icon {
                    font-size: 20px;
                    margin-right: 5px;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        font-size: 16px;
                        margin-right: 3px;
                    }
                }
            }
        }

        .rank-change {
            color: @accent-green;
            font-size: 12px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                font-size: 11px;
            }
        }
    }
}

// Element组件样式适配
.el-card__header {
    border-bottom: 1px solid transparent;
}

.el-tag--warning {
    background-color: rgba(245, 158, 11, 0.2);
    border-color: @accent-yellow;
    color: @accent-yellow;
}

.el-tag--info {
    background-color: rgba(56, 189, 248, 0.2);
    border-color: @accent-blue;
    color: @accent-blue;
}

.el-tag--success {
    background-color: rgba(16, 185, 129, 0.2);
    border-color: @accent-green;
    color: @accent-green;
}

.el-tag--danger {
    background-color: rgba(239, 68, 68, 0.2);
    border-color: @accent-red;
    color: @accent-red;
}

// 滚动条样式优化
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: #1a202c;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: #4a5568;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #718096;
}

// 响应式补充：小屏设备Element UI适配
@media screen and (max-width: 576px) {
    .el-menu {
        --el-menu-text-color: #e2e8f0;
        --el-menu-active-text-color: #38bdf8;
        --el-menu-hover-text-color: #38bdf8;
    }

    .el-menu-item {
        padding: 0 10px !important;
    }
}
</style>